module.exports = __webpack_public_path__ + "img/Sec_XIV_Fragment_din_Vechiul_Testament_de_la_Rasnov_BAR_677_f1.461dccd5.jpg";